import React, { useContext } from 'react';
import { connect } from 'react-redux';
import { Switch, Route, withRouter, Redirect, Link } from 'react-router-dom';
import _ from 'lodash';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import { getJson } from 'session';
import { Acl } from 'modules/common/components/Acl';
import DeathContainer from './container/DeathContainer';
import SearchContainer from './container/search/SearchContainer';
import DeathCertificateListingContainer from './container/records/container/DeathCertificateListingContainer';
import DeathCertificateCsvImportContainer from './container/import-csv/containers/DeathCertificateCsvImportContainer';
// import DeathCertificateSettingsContainer from './container/death-settings/containers/DeathCertificateSettingsContainer';
import QrVerifierModal from './components/QrVerifierModal';
import DeathCertificateFileImportContainer from './container/import-file/containers/DeathCertificateFileImportContainer';

function TabDeath({ match, pathName, permissions }) {
  const setModal = useContext(ModalContext);

  const handleOpenQrVerifierModal = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <QrVerifierModal />,
      title: 'Scan QR Code',
      modalSize: 'modal-md',
    });
  };

  return (
    <React.Fragment>
      <div className="card-content-listing">
        <div className="container-fluid">
          <div className="row">
            <ul className="nav nav-tabs btn-settings-tab-container">
              <li className="nav-item">
                <Link
                  to="/civil-registry/death-certificate"
                  className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                    pathName.indexOf(
                      '/civil-registry/death-certificate/transactions'
                    ) > -1
                      ? 'selected'
                      : ''
                  }`}
                >
                  Death Certificate
                </Link>
              </li>
              {Acl(permissions, ['SEARCH DEATH CERTIFICATE']) && (
                <li className="nav-item">
                  <Link
                    to="/civil-registry/death-certificate/search"
                    className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                      pathName.indexOf(
                        '/civil-registry/death-certificate/search'
                      ) > -1
                        ? 'selected'
                        : ''
                    }`}
                  >
                    Search
                  </Link>
                </li>
              )}
              <li className="nav-item">
                <Link
                  to="/civil-registry/death-certificate/records-maintenance"
                  className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                    pathName.indexOf(
                      '/civil-registry/death-certificate/records-maintenance'
                    ) > -1
                      ? 'selected'
                      : ''
                  }`}
                >
                  Record Maintenance
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/civil-registry/death-certificate/file-import"
                  className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                    pathName.indexOf(
                      '/civil-registry/death-certificate/file-import'
                    ) > -1
                      ? 'selected'
                      : ''
                  }`}
                >
                  File Import
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/civil-registry/death-certificate/csv-import"
                  className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                    pathName.indexOf(
                      '/civil-registry/death-certificate/csv-import'
                    ) > -1
                      ? 'selected'
                      : ''
                  }`}
                >
                  CSV Import
                </Link>
              </li>
              <li className="nav-item">
                <button
                  type="button"
                  onClick={handleOpenQrVerifierModal}
                  className="nav-link btn-settings-tab border-right py-3 px-5 "
                >
                  QR Verifier
                </button>
              </li>
              {/* <li className="nav-item">
                <Link
                  to="/civil-registry/death-certificate/settings"
                  className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                    pathName.indexOf(
                      '/civil-registry/death-certificate/settings'
                    ) > -1
                      ? 'selected'
                      : ''
                  }`}
                >
                  Settings
                </Link>
              </li> */}
            </ul>
          </div>
        </div>
        <Switch>
          <Route
            exact
            path={`${match.path}`}
            render={() => <Redirect to={`${match.path}/transactions`} />}
          />
          <Route
            path={`${match.path}/transactions`}
            component={DeathContainer}
          />
          <Route path={`${match.path}/search`} component={SearchContainer} />
          <Route
            path={`${match.path}/file-import`}
            component={DeathCertificateFileImportContainer}
          />
          <Route
            path={`${match.path}/records-maintenance`}
            component={DeathCertificateListingContainer}
          />
          <Route
            path={`${match.path}/csv-import`}
            component={DeathCertificateCsvImportContainer}
          />
          {/* <Route
            path={`${match.path}/settings`}
            component={DeathCertificateSettingsContainer}
          /> */}
        </Switch>
      </div>
    </React.Fragment>
  );
}

TabDeath.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  pathName: PropTypes.string.isRequired,
  permissions: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }, { match, location }) => ({
  mainModule: _.get(match, 'params.mainModule'),
  pathName: _.get(location, 'pathname'),
  profile: _.get(api, 'AUTH/user_profile.item') || {},
  permissions: getJson('permissions'),
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps)]);

export default enhance(TabDeath);
